import * as types from "./appactiontypes";
import appService from "../services/appservice";
import menuService from "../overrides/menuservices";
import * as securityActions from "./securityactions"
import * as appConstants from "../overrides/appconstants"
export function setLoading(value, preLoadingIndicatorMessage, preLoadingIndicatorOptions) {
  return {
    type: types.SET_LOADING,
    value,
    preLoadingIndicatorMessage,
    preLoadingIndicatorOptions,
  };
}

export function setPreloading(value, loadingIndicatorMessage, loadingIndicatorOptions) {
  return {
    type: types.SET_PRELOADING,
    value,
    loadingIndicatorMessage,
    loadingIndicatorOptions,
  };
}
export function setTopMessage(message) {
  return {
    type: types.SET_TOP_MESSAGE,
    message,
  };
}
export function removeTopMessage(message) {
  return {
    type: types.REMOVE_TOP_MESSAGE,
    message,
  };
}
export function showTopMessage(messageText, messageOptions) {
  if (!messageOptions) messageOptions = {};
  if (!messageOptions.timeout) {
    messageOptions.timeout = 2000;
  }
  if (!messageOptions.messageType) {
    messageOptions.messageType = "default";
  }
  if (!messageOptions.autoClose) {
    messageOptions.autoClose = "y";
  }
  let message = {
    messageText,
    messageOptions,
  };

  return async function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch(setTopMessage(message));
      if (message.messageOptions.autoClose == "y") {
        setTimeout(() => {
          dispatch(removeTopMessage(message));
        }, messageOptions.timeout);
      }
    });
  };
}
//............app message starts
export function showMessage(message, messageOptions) {
  return async function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch(setMessage(message, messageOptions, resolve));
    });
  };
}
export function setMessage(message, messageOptions, messageCallback) {
  return {
    type: types.SET_MESSAGE,
    message,
    messageOptions,
    messageCallback,
  };
}
export function closeMessage() {
  return {
    type: types.CLOSE_MESSAGE,
  };
}
export function showMessageForValidationErrorsCompliants(sr){
  return async function (dispatch) {
    console.log('MICORE showValidationErrors')
    let message = "Kindly find the below mandatory fields that need to be filled:\n";
    sr.errors.forEach((error) => {
      message += error.errorMessage + " \n";
    });
    return dispatch(
      showMessage(message, { buttons: ['Ok'] })
    );
  };
}
export function showValidationErrors(sr) {
  return async function (dispatch) {
    console.log('MICORE showValidationErrors')
    let message = "Validation error(s)\n";
    sr.errors.forEach((error) => {
      message += error.errorMessage + " \n";
    });
    return dispatch(
      showTopMessage(message, { autoClose: "n", messageType: "danger" })
    );
  };
}
export function showMessageForValidationErrors(sr){
  return async function (dispatch) {
    console.log('MICORE showValidationErrors')
    let message = "Validation error(s)\n";
    sr.errors.forEach((error) => {
      message += error.errorMessage + " \n";
    });
    return dispatch(
      showMessage(message, { autoClose: "n", messageType: "danger" })
    );
  };
}
//............app message ends
export function handleError(errorResponse) {
  return async function (dispatch) {
    try {
      return new Promise(async (resolve, reject) => {
        console.log('MICORE handleError')
        let message = null;
        if (
          errorResponse.status !== undefined &&
          errorResponse.responseText !== undefined
        ) {
          if (errorResponse.status === 404) {
            message = "Not found 404";
          } else if (errorResponse.status === 405) {
            message = "Access denied 403";
          } else if (errorResponse.status === 401) {
            try {
              if (errorResponse.getResponseHeader('X-ND-SessionExpired') != null) {
                await dispatch(showMessage('User session expired. Please login again.'));
                dispatch(securityActions.redirectToPage(appConstants.SYSTEM_MENU_ID));
                return;
              }
            } catch (e) { }
            message = "You are not allowed to do the operation : Access denied";
          } else if (errorResponse.status === 500) {
            message = "We encountered an issue while trying to fulfill your request, Request Id:  "
              + errorResponse.getResponseHeader('X-ND-ExceptionRequestId');
          }
          else {
            try {
              let json = JSON.parse(errorResponse.responseText);
              if (json.Message != null) {
                message = json.Message;
              }
            } catch (e) { }
          }
          if (message == null) {
            message =
              "We encountered an issue while trying to fulfill your request code : " +
              errorResponse.status;
          }
        }
        if (message == null) {
          message = "" + errorResponse;
        }
        dispatch(showMessage(message, { buttons: ["Close"] })).then(reject);
      });
    } catch (e) {
      console.log(e);
    }
  };
}
const getUserMenuEnd = (menus) => ({
  type: types.GET_USER_MENU_END,
  payload: menus,
});

export function getUserMenu() {
  return async function (dispatch) {
    try {
      //setLoading(true);
      let resp = await menuService.getUserMenu();
      if (resp) {
        dispatch(getUserMenuEnd(resp));
        //  setLoading(false);
      }
    } catch (e) {
      console.log(e);
    }
  };
}
